import React from 'react'
import Home from '../screens/Home/Home';

export default function MainContainer() {
  return <Home />;
}